"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingsService = exports.settingsService = void 0;
var auth_suite_fetch_1 = require("../../auth-suite-fetch");
var settingsRequestRoute = "settings";
var accessRequestRoute = "".concat(settingsRequestRoute, "/access");
var countryCodesRequestRoute = "".concat(settingsRequestRoute, "/countryCodes");
var getAccessMethods = function () { return requestAccessMethods(); };
var getCountryCodes = function () { return requestGetCountryCodes(); };
var requestGetCountryCodes = function () {
    return auth_suite_fetch_1.authSuiteFetchWithAuthorization.get({
        path: countryCodesRequestRoute,
    });
};
var requestAccessMethods = function () {
    return auth_suite_fetch_1.authSuiteFetchWithAuthorization.get({
        path: accessRequestRoute,
    });
};
exports.settingsService = {
    getAccessMethods: getAccessMethods,
    getCountryCodes: getCountryCodes,
};
var SettingsService = /** @class */ (function () {
    function SettingsService() {
        return exports.settingsService;
    }
    return SettingsService;
}());
exports.SettingsService = SettingsService;
